module.exports = __webpack_public_path__ + "img/49.8150c39a.jpg";